import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';

import { AuthService } from '@app/features/auth/auth.service';
import { TokenDto } from '@app/features/auth/models';

let refreshTokenInProgress = false;
const accessTokenSubject = new BehaviorSubject<TokenDto | null>(null);

export const errorHandlerInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {

  const auth = inject(AuthService);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // Si NO se está refrescando
        if (!refreshTokenInProgress) {
          refreshTokenInProgress = true;
          accessTokenSubject.next(null);

          return auth.getAuthToken().pipe(
            switchMap(authResponse => {

              localStorage.setItem('token', authResponse.result.access_token);

              refreshTokenInProgress = false;
              accessTokenSubject.next(authResponse.result);

              const newRequest = request.clone({
                setHeaders: {
                  authorization: `Bearer ${authResponse.result.access_token}`,
                },
              });

              return next(newRequest);
            }),
            catchError(err => {
              refreshTokenInProgress = false;
              return throwError(() => err);
            })
          );

        } else {
          // Si ya hay refresh en progreso → esperar en cola
          return accessTokenSubject.pipe(
            filter(result => result?.access_token !== null),
            take(1),
            switchMap(token => {
              const newRequest = request.clone({
                setHeaders: {
                  authorization: `Bearer ${token!.access_token}`,
                },
              });
              return next(newRequest);
            })
          );
        }
      }

      return throwError(() => error);
    })
  );
};
